// src/components/DeleteAccountRequest.js
import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';
import './DeleteAccountRequest.css';

const DeleteAccountRequest = () => {
  const { user } = useAuth();
  const [showDialog, setShowDialog] = useState(false);
  const [reason,     setReason]     = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted,  setSubmitted]  = useState(false);
  const [error,      setError]      = useState('');

  const handleSubmit = async () => {
    setSubmitting(true);
    setError('');
    try {
      await addDoc(collection(db, 'deletionRequests'), {
        uid:         user.uid,
        email:       user.email,
        displayName: user.name || user.email,
        role:        user.type,
        reason:      reason.trim(),
        status:      'pending',
        requestedAt: serverTimestamp(),
      });
      setSubmitted(true);
      setShowDialog(false);
    } catch (err) {
      console.error('[DeleteAccountRequest]', err);
      setError('Failed to submit request. Please try again.');
    }
    setSubmitting(false);
  };

  const handleCancel = () => {
    setShowDialog(false);
    setReason('');
    setError('');
  };

  if (submitted) {
    return (
      <div className="dar-section">
        <div className="dar-success">
          ✓ Your deletion request has been submitted. We will review and process it within 30 days.
        </div>
      </div>
    );
  }

  return (
    <div className="dar-section">
      {!showDialog ? (
        <button type="button" className="btn dar-btn" onClick={() => setShowDialog(true)}>
          🗑 Request Account Deletion
        </button>
      ) : (
        <div className="dar-dialog">
          <div className="dar-dialog-title">⚠️ Request Account Deletion</div>
          <p className="dar-dialog-text">
            Are you sure you want to request account deletion? Your request will be reviewed
            and processed within 30 days.
          </p>
          <div className="dar-form-group">
            <label className="dar-label">Reason (optional)</label>
            <textarea
              className="dar-textarea"
              placeholder="Tell us why you're leaving..."
              value={reason}
              onChange={e => setReason(e.target.value)}
              rows={3}
            />
          </div>
          {error && <div className="dar-error">{error}</div>}
          <div className="dar-actions">
            <button type="button" className="btn btn-outline dar-cancel" onClick={handleCancel}>
              CANCEL
            </button>
            <button
              type="button"
              className="btn dar-submit"
              onClick={handleSubmit}
              disabled={submitting}
            >
              {submitting ? 'SUBMITTING...' : 'SUBMIT REQUEST'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteAccountRequest;
